import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  AppContext,
  LOG_IN_SUCCESS,
  MENU_SET_ALL,
  SET_APP_ALL,
  SET_USER_HEALTH,
  SocketCommand,
  socketManager,
} from "../../components/AppProvider";
import { AlertLayer } from "../../components/UI/Dialog";
import {
  PostApi156,
  PostApi157,
  PostApi160,
  PostApi161,
  PostApi1902,
  PostApi1910,
  PostApi1913,
  PostApi1930,
} from "../../modules/network/padoPost";
import { _O } from "../../modules/utils";
import { maxLengthCheck } from "../../modules/utils/CheckLogic";
import { setCookie, setCookieWs } from "../../modules/utils/cookie";
import { Container, openLayerFn } from "../Layout";
import { addHspt } from "../Settings/ConnectHospital/ConnectHospital";
import { ExistIdLayer } from "../common/Modal/ExistIdLayer";
import { loginLogInterface } from "./Login";

export default (props) => {
  const { userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);

  const [joinInfo, setJoinInfo] = useState({});
  const [dupList, setDupList] = useState("");
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [gender, setGender] = useState("");
  const [inputInfo, setInputInfo] = useState({});

  const [dialog, setDialog] = useState({ title: "", msg: "" });

  const handleAlert = (title, msg) => {
    setDialog({ title: title, msg: msg });

    openLayerFn($(".alert-layer"));
  };

  const handleAlertCB = () => {
    if (loginSuccess) {
      // 메인화면 이동
      _O.OpenMenu("/");
    }
  };

  const submit = () => {
    if (props.match.params.submit != "certi") {
      // if($("#inputName").val() && $("#inputBirth").val() && $("#inputPhone").val())
      // {
      if (
        $("#inputName").val() == "" ||
        $("#inputBirth").val() == "" ||
        $("#inputPhone").val() == "" ||
        gender == ""
      ) {
        handleAlert("", "환자정보를 입력하세요.");
        return;
      }

      if ($("#inputBirth").val() && $("#inputBirth").val().length < 8) {
        handleAlert("", "생년월일 8자리를 입력하세요.");
        return;
      }

      const date_pattern = /^(19|20)\d{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[0-1])$/;

      if ($("#inputBirth").val() && !date_pattern.test($("#inputBirth").val())) {
        handleAlert("", "생년월일 8자리를 입력하세요.");
        return;
      }
      // }
    }

    if (props.match.params.submit === "regist") {
      if (props.match.params.userInfo === "1") {
        // alert("로그인");
        registToAttctNo();
      } else {
        // 가입정보 확인-가입
        request161("/membership/help/vrfcn/1/green/certi/");
      }
    }

    if (props.match.params.submit === "info") {
      request161("/membership/help/vrfcn/1/green/certi/");
    }

    if (props.match.params.submit === "certi") {
      // alert("재로그인");
      registToAttctNo();
    }

    if (props.match.params.submit === "SMS") {
      if (props.match.params.userInfo === "1") {
        request157();
      } else {
        setInputInfo({
          userId: $("#inputPhone").val().trim(),
          userName: $("#inputName").val().trim(),
          userPhone: $("#inputPhone").val().trim(),
          userBirth: $("#inputBirth").val().trim(),
          gender: gender,
        });
        request160();
      }
    }

    if (props.match.params.submit === "SMSLOGIN") {
      request157("SMSLOGIN");
    }
  };

  const request160 = (url) => {
    PostApi160(
      phonecfg,
      cfg,
      $("#inputName").val().trim(),
      $("#inputBirth").val().trim(),
      $("#inputPhone").val().trim(),
      gender
    )
      .then((res) => {
        if (res.resultCode === "000") {
          if (res.joinInfo.length > 2) {
            setDupList(res.joinInfo);
            openLayerFn($("#existLayer"));
          } else {
            // signUpChannel = 500 -> 즉시 로그인 signUpChannel = 000 -> 비밀번호 변경
            if (res.joinInfo[0].signUpChannel === "000") {
              setJoinInfo(res.joinInfo);

              setInputInfo({
                userId: res.joinInfo[0].userId,
                userName: res.joinInfo[0].userName,
                userPhone: res.joinInfo[0].userPhone,
                userBirth: res.joinInfo[0].birth,
                gender: gender,
              });

              request156("/membership/help/vrfcn/1/purple/SMS/", res.joinInfo);
            } else if (res.joinInfo[0].signUpChannel === "500") {
              setJoinInfo(res.joinInfo[0]);
              request156("/membership/help/vrfcn/1/purple/SMSLOGIN/");
            } else {
              setDupList(res.joinInfo);
              openLayerFn($("#existLayer"));
            }
          }
        }
      })
      .catch((err) => {
        handleAlert("", "시스템 오류 입니다.");
        console.log("### SYSTEM ERR : ", err);
      });
  };

  const request161 = (url) => {
    PostApi161(
      phonecfg,
      cfg,
      $("#inputName").val().trim(),
      $("#inputBirth").val().trim(),
      $("#inputPhone").val().trim(),
      gender
    )
      .then((res) => {
        if (res.resultCode === "000") {
          if (props.match.params.submit === "regist") {
            registSubmit(res, setDupList, props, cfg, phonecfg, handleAlert, url);
          } else {
            infoSubmit(res, setDupList, props, cfg, phonecfg, handleAlert, url);
          }
        }
      })
      .catch((err) => {
        handleAlert("", "시스템 오류 입니다.");
        console.log("### SYSTEM ERR : ", err);
      });
  };

  const request156 = (url, joinInfo) => {
    let userId;
    let userName;
    let userBirth;
    let userPhone;

    if (joinInfo) {
      userId = joinInfo[0].userId;
      userName = joinInfo[0].userName;
      userBirth = joinInfo[0].birth;
      userPhone = joinInfo[0].userPhone;
    } else {
      userId = $("#inputPhone").val().trim();
      userName = $("#inputName").val().trim();
      userBirth = $("#inputBirth").val().trim();
      userPhone = $("#inputPhone").val().trim();
    }

    PostApi156(phonecfg, cfg, userId, userName, userBirth, userPhone).then((res) => {
      if (res.resultCode === "000") {
        if (res.result === 1) {
          setTimeout(() => {
            _O.Open(url);
          }, 500);
        } else {
          handleAlert("", "입력정보를 확인하세요.");
        }
      } else {
        handleAlert(
          "",
          "등록한 정보와 일치하지 않습니다.<br />입력한 내용에 문제가 없는 경우 1877-4872로 문의하세요."
        );
      }
    });
  };

  const request157 = (type) => {
    PostApi157(
      phonecfg,
      cfg,
      inputInfo.userId,
      inputInfo.userName,
      inputInfo.userBirth,
      inputInfo.userPhone,
      $("#attctNoParam").val()
    ).then((res) => {
      if (res.resultCode === "000") {
        if (res.result === 1) {
          if (type === "SMSLOGIN") {
            setLoginSuccess(true);
            handleLoginSuccess500(joinInfo, "SMSLOGIN");

            setTimeout(() => {
              socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
                login: "in",
                userToken: joinInfo[0].userToken.toString(),
              });
            }, 2000);
          } else {
            _O.Open("/membership/changePwd/" + inputInfo.userId + "/" + $("#attctNoParam").val());
          }
        } else {
          handleAlert("", "입력한 정보를 확인하세요.");
          // handleAlert('', '잘못된 인증번호입니다.'); 인증번호가 잘못되었을경우 인증번호 발송이후 회원정보가 바뀐 경우
        }
      } else {
        handleAlert(
          "",
          "등록한 정보와 일치하지 않습니다.<br />입력한 내용에 문제가 없는 경우 1877-4872로 문의하세요."
        );
      }
    });
  };

  const request1910 = (userinfo, cardType) => {
    PostApi1910(userinfo, cfg, phonecfg, cardType)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;

          if (data.length > 0) dispatch({ type: MENU_SET_ALL, menutype: cardType, data: data });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const request1913 = (userinfo) => {
    PostApi1913(userinfo, cfg, phonecfg)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;
          dispatch({ type: SET_APP_ALL, data: data });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const setUserHlthInfo = (userinfo) => {
    PostApi1902(userinfo, cfg, phonecfg)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result) {
            dispatch({ type: SET_USER_HEALTH, data: res.result });
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLoginSuccess500 = (res, type) => {
    // dispatch({ type: LOG_IN_SUCCESS, data: res.resultList[0], isAutoLogin:
    // isAutoLogin});
    let loginInfo;

    if (type === "SMSLOGIN") {
      loginInfo = res;
    } else {
      loginInfo = res.loginInfo[0];
    }

    dispatch({ type: LOG_IN_SUCCESS, data: loginInfo, isAutoLogin: true });
    loginLogInterface(loginInfo, phonecfg, cfg, "I", "M", loginInfo.signUpChannel);

    setCookie("signUpChannel", "500", 1);
    setCookieWs({ isAutoLogin: true, signUpChannel: "500" });

    socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
      login: "in",
      userToken: loginInfo.userToken.toString(),
    });
    request1910(loginInfo, "");
    request1913(loginInfo);
    setUserHlthInfo(loginInfo);
    // handleAlert('확인', `계정은 휴대폰번호이며 초기 비밀번호는 생년월일 입니다.`);
    $("#exchangeTargetLogin").attr("id", "welcomeLogin");
    handleAlert("확인", `케어포미에 오신 것을 환영합니다.`);
  };

  const registToAttctNo = () => {
    PostApi1930(userinfo, cfg, phonecfg, "N", $("#attctNoParam").val())
      .then((res) => {
        if (res.resultCode === "000") {
          setJoinInfo(res.joinInfo);
          // attctNoVal = '';
          $("#attctNoParam").val("");
        } else if (res.resultCode === "003") {
          setDupList(res.loginInfo);
          openLayerFn($("#existLayer"));
        } else if (res.resultCode === "004") {
          setLoginSuccess(true);
          handleLoginSuccess500(res);

          setCookie("signUpChannel", "500", 1);
          setCookieWs({ isAutoLogin: true, signUpChannel: "500" });

          setTimeout(() => {
            socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
              login: "in",
              userToken: res.resultList[0].userToken.toString(),
            });
          }, 2000);
        } else {
          handleAlert("", "인증번호를 확인하세요.");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.match.params.attctNo) {
      $("#attctNoParam").val(props.match.params.attctNo);
    }
  }, [props.match.params.attctNo]);

  return (
    <Fragment>
      <Container
        dark={"dark"}
        isMain={false}
        Title={"회원정보"}
        proof={"PICBTN"}
        goToUrl="/membership/help"
        onClick={() => submit()}
      >
        <div className="contents">
          <div className="sub-contents">
            <div className="patient-info-contain">
              <div className="patientinfo-wrap">
                <div className="round-list mauve">
                  {props.match.params.userInfo === "1" && (
                    <SubTitle color={props.match.params.color} submit={props.match.params.submit} />
                  )}

                  {props.match.params.userInfo === "0" && <UserInfo setGender={setGender} />}

                  {props.match.params.userInfo === "1" && (
                    <Certification
                      inputName={$("#inputName").val()}
                      inputBirth={$("#inputBirth").val()}
                      inputGender={gender}
                      inputPhone={$("#inputPhone").val()}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <AlertLayer title={dialog.title} msg={dialog.msg} handleConfirmCB={handleAlertCB} />
      <ExistIdLayer dupList={dupList} />
    </Fragment>
  );
};

export const SubTitle = (props) => {
  const { color, submit } = props;
  return (
    <div
      className="title"
      style={
        color === "green"
          ? {
              background: "#afddd4",
              color: "#3c5a54",
            }
          : {}
      }
    >
      {submit === "SMS" ? (
        <>
          {" "}
          <i className="c1"> </i>SMS로 발급된 인증번호를 입력하세요.
        </>
      ) : (
        <>
          {" "}
          <i className="c1"> </i>병원에 방문하여 인증번호를 발급해 주세요.
        </>
      )}
    </div>
  );
};

export const UserInfo = (props) => {
  const { setGender } = props;

  return (
    <div className="section-box">
      <div className="sub-title">개인정보</div>

      <div className="patientinfo-list">
        <ul>
          <UserInfoName />
          <UserInfoId setGender={setGender} />
          <UserInfoPhone />
        </ul>
      </div>
    </div>
  );
};

export const UserInfoName = () => {
  return (
    <li>
      <div>
        <input
          type="text"
          id="inputName"
          className="textbox fs2"
          maxLength={10}
          placeholder="이름을 입력해 주세요."
        />
      </div>
    </li>
  );
};

export const UserInfoId = (props) => {
  const { setGender } = props;
  return (
    <li className="select-input">
      <UserInfoBirth />
      <UserInfoGender setGender={setGender} />
    </li>
  );
};

export const UserInfoBirth = () => {
  return (
    <div className="calendar_wrap">
      <input
        type="number"
        pattern="\d*"
        id="inputBirth"
        name="class_day"
        className="textbox class_day "
        placeholder="생년월일 8자리를 입력해 주세요."
        onChange={(e) => maxLengthCheck(e, 8)}
      />
    </div>
  );
};

export const UserInfoGender = (props) => {
  const { setGender } = props;

  return (
    <div>
      <div className="select-custom-box">
        <a className="btn-select ">성별</a>
        <ul>
          <li onClick={() => setGender("1")}>
            <a>남자</a>
          </li>
          <li onClick={() => setGender("0")}>
            <a>여자</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export const UserInfoPhone = () => {
  return (
    <li>
      <div>
        <input
          type="number"
          pattern="\d*"
          id="inputPhone"
          className="textbox fs2"
          onChange={(e) => maxLengthCheck(e, 11)}
          placeholder="휴대폰 번호를 입력해주세요."
        />
      </div>
    </li>
  );
};

export const Certification = () => {
  return (
    <div className="section-box">
      <div className="sub-title">인증번호</div>

      <div className="patientinfo-list">
        <ul>
          <li>
            <div>
              <input
                type="text"
                className="textbox fs2"
                id="attctNoParam"
                maxLength={6}
                placeholder="발급받은 인증번호를 입력해 주세요."
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

const registSubmit = (res, setDupList, props, cfg, phonecfg, handleAlert, url) => {
  if (res.joinInfo.length > 1) {
    setDupList(res.joinInfo);
    openLayerFn($("#existLayer"));
  } else {
    let addList = [props.match.params.hsptList];
    addHspt(
      {
        userToken: res.joinInfo[0].userToken,
      },
      cfg,
      phonecfg,
      1,
      addList,
      handleAlert,
      true
    );

    setTimeout(() => {
      _O.Open(url);
    }, 500);
  }
};

const infoSubmit = (res, setDupList, props, cfg, phonecfg, handleAlert, url) => {
  if (res.joinInfo.length > 2) {
    setDupList(res.joinInfo);
    openLayerFn($("#existLayer"));
  } else {
    let addList = [props.match.params.hsptList];
    addHspt(
      {
        userToken: res.joinInfo[0].userToken,
      },
      cfg,
      phonecfg,
      1,
      addList,
      handleAlert,
      true
    );

    setTimeout(() => {
      _O.Open(url);
    }, 500);
  }
};
